import cx from 'classnames'
import {AppearanceProvider} from 'components/common/CartItemBuilder/providers/AppearanceProvider'
import {Button} from 'components/system/Button'
import {ApplyButton} from '../../ApplyButton'

type Props = {
  onError: (error: unknown) => void
}

export const ConfirmButton = ({onError}: Props) => {
  const builderManager = AppearanceProvider.useManager()

  return (
    <ApplyButton
      onClick={builderManager.setPreviewMode}
      onError={onError}
      render={({onClick, disabled}) => {
        return (
          <Button.Primary.Orange
            onClick={onClick}
            autoExpanded
            className={cx(disabled ? '!bg-inactive-gray' : '!bg-theme')}
          >
            Confirm
          </Button.Primary.Orange>
        )
      }}
    />
  )
}
